import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';

const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'https://greenlyelectronicsrecycling.com';

const ContactJsonLd = () => (
  <script type="application/ld+json">{JSON.stringify({
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "@id": `${SITE_URL}/contact#webpage`,
    "url": `${SITE_URL}/contact`,
    "name": "Contact Greenly Electronics Recycling | Los Angeles E-Waste Pickup & Drop-Off",
    "description": "Contact Greenly Electronics Recycling in Los Angeles. Schedule a free e-waste pickup, drop off electronics, or get a quote. Call (213) 600-1000 or fill out our contact form.",
    "isPartOf": { "@id": `${SITE_URL}/#website` },
    "about": { "@id": `${SITE_URL}/#business` },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Home", "item": `${SITE_URL}/` },
        { "@type": "ListItem", "position": 2, "name": "Contact", "item": `${SITE_URL}/contact` }
      ]
    }
  })}</script>
);

const ContactPage = () => (
  <>
    <title>Contact Greenly Electronics Recycling | Los Angeles E-Waste Pickup &amp; Drop-Off</title>
    <meta name="description" content="Contact Greenly Electronics Recycling in Los Angeles. Schedule a free e-waste pickup or drop off electronics. Call (213) 600-1000. Two LA locations: W 3rd St & W Slauson Ave." />
    <meta name="keywords" content="contact electronics recycling Los Angeles, e-waste pickup Los Angeles, schedule recycling pickup LA, Greenly contact" />
    <meta name="robots" content="index, follow" />
    <meta name="last-modified" content="2026-05-11" />
    <link rel="canonical" href={`${SITE_URL}/contact`} />
    <ContactJsonLd />
    <Navbar />
    <main>
      {/* Header */}
      <section className="bg-[#0F3D22] pt-28 pb-14 px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <Breadcrumb items={[{ label: 'Contact' }]} />
          <h1 className="text-3xl md:text-4xl font-bold text-white mt-4 mb-3">Contact Us</h1>
          <p className="text-green-200 max-w-xl text-base leading-relaxed">
            Ready to schedule a pickup, drop off electronics, or get a quote? We&apos;re here to help.
          </p>
        </div>
      </section>

      {/* Main content */}
      <section className="py-16 md:py-20 bg-[#F4FAF7]">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
            <div className="lg:col-span-2">
              <ContactInfo />
            </div>
            <div className="lg:col-span-3">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      {/* Maps — both locations */}
      <section className="grid grid-cols-1 md:grid-cols-2">
        <div className="relative h-80">
          <iframe
            title="Greenly Electronics Recycling — 2542 W 3rd Street Los Angeles"
            src="https://maps.google.com/maps?q=Greenly+Electronics+Recycling+%26+Data+Destruction,+2542+W+3rd+St,+Los+Angeles,+CA+90057&output=embed&z=16"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
          <div className="absolute bottom-0 left-0 right-0 bg-[#1B6B3A] text-white text-xs font-semibold px-4 py-2 flex items-center gap-2">
            <i className="ri-map-pin-2-fill text-[#74C69D]"></i>
            2542 W. 3rd Street, Los Angeles, CA 90057
          </div>
        </div>
        <div className="relative h-80">
          <iframe
            title="Greenly Electronics Recycling — 4902 W Slauson Ave Los Angeles"
            src="https://maps.google.com/maps?q=4902+W+Slauson+Ave,+Los+Angeles,+CA+90056&output=embed&z=16"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
          <div className="absolute bottom-0 left-0 right-0 bg-[#1B6B3A] text-white text-xs font-semibold px-4 py-2 flex items-center gap-2">
            <i className="ri-map-pin-2-fill text-[#74C69D]"></i>
            4902 W. Slauson Ave, Los Angeles, CA 90056
          </div>
        </div>
      </section>
    </main>
    <Footer />
  </>
);

export default ContactPage;
